<template>
    <div
        class="photo-uploader"
        data-qe-id="photo-uploader_clear-all_button"
        @click="clearFiles"
        v-if="isTypeButton || isTypeAddMore || isTypeIcon || buttonLabel">
        <file-upload
            :class="['photo-uploader__btn', isTypeAddMore ? 'photo-uploader__btn--expanded' : '']"
            :extensions="extensions"
            :accept="accept"
            :multiple="multiple"
            v-model="files"
            :maximum="maximumFiles"
            :thread="3"
            :input-id="uploaderId"
            @input-file="inputFile"
            @input-filter="inputFilter"
            :data-qe-id="uploaderId"
            ref="photoUploader">
            <v-icon color="ypo_blue" v-if="isTypeButton || isTypeIcon">photo</v-icon>
            <span class="photo-uploader__btn-label" v-if="isTypeButton">{{ photoUploaderConstant.labels.PHOTOS }}/{{ photoUploaderConstant.labels.VIDEOS }}</span>
            <v-icon
                color="ypo_blue"
                class="photo-uploader__add-more"
                size="30"
                v-if="isTypeAddMore">add</v-icon>
            <span class="photo-uploader__btn-label"> {{buttonLabel}} </span>
        </file-upload>

        <transition name="fade" v-if="!hideError">
            <p data-qe-id="photo_upload_error" class="photo-uploader__error">{{ errorMessage }}</p>
        </transition>
    </div>
</template>

<script>
    import FileUpload from 'vue-upload-component';
    import uniqBy from 'lodash/uniqBy';
    import { photoUploaderConstant } from './photoUploader.constant';
    import { appCommonConstants } from '../appCommon.constants';

    export default {
        name: 'PhotoUploader',
        components: {
            FileUpload,
        },
        created() {},
        data() {
            return {
                files: [],
                name: 'file',
                photoUploaderConstant,
                errorMessage: '',
                appCommonConstants,
            };
        },
        props: {
            uploaderId: {
                type: String,
                required: true,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            uploadCallback: {
                type: Function,
                required: true,
            },
            buttonLabel: {
                type: String,
            },
            isTypeButton: {
                type: Boolean,
                default: false,
            },
            isTypeIcon: {
                type: Boolean,
                default: false,
            },
            isTypeAddMore: {
                type: Boolean,
                default: false,
            },
            maximumFiles: {
                type: Number,
                default: 1,
            },
            fileSizeFromOtherSources: {
                type: Number,
                default: 0, //bytes
            },
            maxFileSizeLimit: {
                type: Number,
                default: 25 * (1024 * 1024), // 25MB
            },
            alreadyAddedImages: {
                type: Array,
                default: () => [],
            },
            extensions: {
                type: String,
                default: `${appCommonConstants.IMAGE_FILE_TYPE_EXTENSIONS},${appCommonConstants.VIDEO_FILE_TYPES_EXTENSIONS}`,
            },
            accept: {
                type: String,
                default: `${appCommonConstants.IMAGE_FILE_TYPES_ACCEPTED},${appCommonConstants.VIDEO_FILE_TYPES_ACCEPTED}`,
            },
            hideError: {
              type: Boolean,
              default: false,
            },
        },
        methods: {
            clearFiles() {
                //clearing files before each input
                this.files = [];
            },
            inputFilter(newFile, oldFile, prevent) {
                const result = !/\.(jpg|jpeg|png|mp4|gif)$/i.test(newFile.name);
                if (result) {
                    this.errorMessage = photoUploaderConstant.error.INVALID_FILE_TYPE;
                    setTimeout(() => {
                        this.errorMessage = '';
                    }, 3000);
                    return prevent();
                }
            },
            validateFileSize(files) {
                const bytes = files.reduce((size, file) => {
                    return size + file.size;
                }, 0);
                return bytes + this.fileSizeFromOtherSources < this.maxFileSizeLimit;
            },
            validateDuplicateName(files) {
                return uniqBy(files, 'name').length === files.length;
            },
            validateImages(images) {
                if (!this.validateFileSize(images)) {
                    this.errorMessage = photoUploaderConstant.error.FILE_SIZE_EXCEEDED;
                    setTimeout(() => {
                        this.errorMessage = '';
                    }, 3000);
                    return false;
                } else if (!this.validateDuplicateName([...images, ...this.alreadyAddedImages])) {
                    this.errorMessage = photoUploaderConstant.error.UPLOADED_IMAGE_ALREADY_EXIST;
                    setTimeout(() => {
                        this.errorMessage = '';
                    }, 3000);
                }
                return true;
            },
            inputFile() {
                if (this.files.length > 0) {
                    if (this.validateImages(this.files)) {
                        this.files.forEach((newFile) => {
                            if (newFile) {
                                const URL = window.URL || window.webkitURL;
                                if (URL && URL.createObjectURL) {
                                    newFile.url = URL.createObjectURL(newFile.file);
                                }
                            }
                        });
                        this.uploadCallback(this.files);
                    }
                }
            },
        },
    };
</script>

<style lang="scss">
    @import '../../common/styles/_colors.scss';

    .photo-uploader {
        height: 100%;

        * {
            cursor: pointer;
        }

        &__btn {
            background-color: $ypo-medium-gray;
            padding: 4px 10px;
            border: 1px solid $ypo-medium-gray;
            border-radius: 4px;
            font-size: 14px;
            margin-top: 5px;

            .v-icon {
                font-size: 18px;
            }

            &:hover {
                background-color: $ypo-open-blue-gray !important;
            }

            &-label {
                color: $ypo-blue;
                padding-left: 5px;
                font-weight: 600;
            }

            &--expanded {
                height: 100% !important;
                width: 100% !important;
                background-color: white;
                border-radius: 0;
                border: none;
                min-height: 155px;
            }
        }

        &__add-more {
            margin-top: 25%;
        }

        &__error {
            font-size: 12px;
            color: $ypo-error-red;
        }
    }
</style>
